import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../img/Axxess_Logo-01.svg'


const _hoisted_1 = { id: "jitsi-wrapper" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between py-2 px-3 text-black font-size-md header-custom-border jitsi-header position-relative" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "img-div" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "axxess-key-logo",
    src: _imports_0
  })
], -1 /* HOISTED */)
const _hoisted_5 = { class: "ms-3 small" }
const _hoisted_6 = {
  key: 0,
  class: "room-name-div"
}
const _hoisted_7 = {
  key: 1,
  class: "room-name-div"
}
const _hoisted_8 = { class: "jitsi-video jitsi-container" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "invited-users-header" }
const _hoisted_11 = {
  key: 0,
  class: "ms-n3"
}
const _hoisted_12 = { class: "invited-participants-header" }
const _hoisted_13 = {
  key: 0,
  class: "ms-n3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JitsiMeeting = _resolveComponent("JitsiMeeting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.timer), 1 /* TEXT */)
      ]),
      (_ctx.roomName)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.roomName), 1 /* TEXT */))
        : (_ctx.roomInfo.roomName)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.sliceRoomId(_ctx.roomInfo.roomName)), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: "text-danger bg-white jitsi-cancel-btn fas fa-times-circle",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!_ctx.loading && _ctx.roomInfo)
        ? (_openBlock(), _createBlock(_component_JitsiMeeting, {
            key: 0,
            domain: _ctx.domain,
            roomName: _ctx.roomInfo.roomName,
            jwt: _ctx.jwt,
            fileRecordingsEnabled: "false",
            options: _ctx.jitsiOptions,
            configOverwrite: _ctx.configOverwrite,
            interfaceConfigOverwrite: _ctx.jitsiOptions.interfaceConfigOverwrite,
            onOnJitsiMeetJSLoaded: _ctx.handleJitsiMeetJSLoaded,
            onOnConferenceJoined: _ctx.handleConferenceJoined,
            onOnReadyToClose: _ctx.handleConferenceLeft,
            onOnApiReady: _ctx.handleApiReady,
            onOnError: _ctx.handleError,
            width: _ctx.meetingWidth,
            height: "500px"
          }, null, 8 /* PROPS */, ["domain", "roomName", "jwt", "options", "configOverwrite", "interfaceConfigOverwrite", "onOnJitsiMeetJSLoaded", "onOnConferenceJoined", "onOnReadyToClose", "onOnApiReady", "onOnError", "width"]))
        : _createCommentVNode("v-if", true),
      (_ctx.participantsPaneOpen && _ctx.invitedParticipants.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["invited-participants-list", [{ shrunk: !_ctx.otherParticipantsOpen, list: _ctx.otherParticipantsOpen }]]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (!_ctx.otherParticipantsOpen ? _ctx.toggleOtherParticipants : null))
            }, [
              _createElementVNode("div", _hoisted_10, [
                (_ctx.otherParticipantsOpen)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, "Other Participants (" + _toDisplayString(_ctx.invitedParticipants.length) + ")", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("i", {
                  title: "toggle other participants view",
                  class: _normalizeClass(["fas jtitsi-toggle-icon", [_ctx.otherParticipantsOpen ? 'fa-eye-slash ' : 'fa-users']]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleOtherParticipants && _ctx.toggleOtherParticipants(...args)))
                }, null, 2 /* CLASS */)
              ]),
              (_ctx.otherParticipantsOpen)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitedParticipants, (invitedParticipant) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "invited-participant-item",
                        key: invitedParticipant.id
                      }, _toDisplayString(invitedParticipant.displayName), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}